module.exports = __webpack_public_path__ + "static/media/logo.7a7c66bf.png";